import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_FREE_SHIPPING_COUPON } from '@/providers/coupon/FreeShippingFormProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/free-shipping')(
  composeCouponRouteTemplate(DEFAULT_FREE_SHIPPING_COUPON),
)
